import moment from 'moment';
import classnames from 'classnames';

export const getExceptionHighlightClassnames = (exception) => {
  if (!exception) return;

  const { shipper, release_time } = exception;
  const status = shipper && shipper.status ? shipper.status : '';
  const diff = moment().diff(moment(release_time), 'hours');

  const classNames = classnames({
    'bg-gray-100': true,
    'bg-blue-100':
      ['Service Watch', 'New Customer'].indexOf(status) > -1 &&
      !exception.on_hold,
    'bg-yellow-200': exception.on_hold,
    'bg-red-50': diff >= 1 && diff < 2 && !exception.on_hold,
    'bg-red-100': diff >= 2 && diff < 3 && !exception.on_hold,
    'bg-red-200': diff >= 3 && !exception.on_hold,
  });

  return classNames;
};

export const shipmentExceptionAliases = {
  'pod': 'invalid_pod',
}
